export default __webpack_public_path__ + "static/media/HomeForOneNight_07.0761adc6.png";